import type { DashboardResponse } from '@common/types/insights';
import { useQuery } from '@tanstack/react-query';
import { getDashboard } from '@/services/InsightsService';

export function useDashboard(lawFirmId: number | undefined) {
    return useQuery<DashboardResponse | null>({
        queryKey: ['insights', 'dashboard', lawFirmId],
        queryFn: async () => {
            if (lawFirmId === undefined) return null;
            const res = await getDashboard({ lawFirmId });
            return res.data;
        },
        enabled: lawFirmId !== undefined,
        staleTime: 5 * 60_000,
    });
}
